import classnames from 'classnames/bind';
import style from './company.module.scss';

const cx = classnames.bind(style);

const InterviewPracticeGateCompany = () => {
  return (
    <div className={cx('contentWrap')}>
      <div className={cx('content')}>
        <div className={cx('text')}>
          <span>취업 준비생이 가고 싶어하는 인기기업</span>
          <strong>
            면접 예상 질문&nbsp;
            <span>10,000</span>
            개가 준비되어 있어요
          </strong>
        </div>
        <div className={cx('divider')} />
      </div>
    </div>
  );
};

export default InterviewPracticeGateCompany;
